import createIcon from '../../createIcon';

/**
 * @component @name Fastfood
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguMDYgMjIuOTk1OUgxOS43MkMyMC41NiAyMi45OTU5IDIxLjI1IDIyLjM1NTkgMjEuMzUgMjEuNTM1OUwyMyA1LjA1NTg2SDE4VjEuMDA1ODZIMTYuMDNWNS4wNTU4NkgxMS4wNkwxMS4zNiA3LjM5NTg2QzEzLjA3IDcuODY1ODYgMTQuNjcgOC43MTU4NiAxNS42MyA5LjY1NTg2QzE3LjA3IDExLjA3NTkgMTguMDYgMTIuNTQ1OSAxOC4wNiAxNC45NDU5VjIyLjk5NTlaTTEgMjEuOTk1OVYyMS4wMDU5SDE2LjAzVjIxLjk5NTlDMTYuMDMgMjIuNTQ1OSAxNS41OCAyMi45OTU5IDE1LjAyIDIyLjk5NTlIMi4wMUMxLjQ1IDIyLjk5NTkgMSAyMi41NDU5IDEgMjEuOTk1OVpNMTYuMDMgMTQuOTk1OUMxNi4wMyA2Ljk5NTg2IDEgNi45OTU4NiAxIDE0Ljk5NTlIMTYuMDNaTTEuMDIgMTcuMDA1OUgxNi4wMlYxOS4wMDU5SDEuMDJWMTcuMDA1OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Fastfood = createIcon('Fastfood', [
  [
    'path',
    {
      d: 'M18.06 22.9959H19.72C20.56 22.9959 21.25 22.3559 21.35 21.5359L23 5.05586H18V1.00586H16.03V5.05586H11.06L11.36 7.39586C13.07 7.86586 14.67 8.71586 15.63 9.65586C17.07 11.0759 18.06 12.5459 18.06 14.9459V22.9959ZM1 21.9959V21.0059H16.03V21.9959C16.03 22.5459 15.58 22.9959 15.02 22.9959H2.01C1.45 22.9959 1 22.5459 1 21.9959ZM16.03 14.9959C16.03 6.99586 1 6.99586 1 14.9959H16.03ZM1.02 17.0059H16.02V19.0059H1.02V17.0059Z',
      key: '1k2a9y',
    },
  ],
]);

export default Fastfood;
